import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import ICONS, { ICON_COLORS } from "../config/icon";
import ChangeCourseDateModal from "./ChangeCourseDateModal";
import PdfSignerModal from "./PdfSignerModal";

function CourseCardDashboard({ course }) {
  const { userId } = useAuth();
  const [openSigner, setOpenSigner] = useState(false);

  const Icon = ICONS[course.iconName] || ICONS.default;
  const colorClass = ICON_COLORS[course.iconName] || ICON_COLORS.default;

  const formattedDate =
    course.customDate && course.customDate !== "null"
      ? new Date(course.customDate).toLocaleDateString("de-DE")
      : course.startDate
      ? new Date(course.startDate).toLocaleDateString("de-DE")
      : "nicht festgelegt";

  const pdfUrl = course.pdfPath ? `https://www.denisbitter.de/stage01/uploads/${course.pdfPath}` : null;
  const pdfUrlSigned = course.pdfPathSigned
    ? `https://www.denisbitter.de/stage01/uploads/signed/${course.pdfPathSigned}`
    : null;

  const queryParams = new URLSearchParams({
    user: userId,
    registration: course.registrationId,
    title: course.title,
    date: formattedDate,
  }).toString();

  const btnClass =
    "w-full py-2 text-xs font-mono text-[#AC8E66] bg-[#1c1c1c] border border-[#AC8E66]/30 rounded hover:border-[#AC8E66]/60 hover:bg-[#1e1e1e] transition-all cursor-pointer text-center block";

  return (
    <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-lg shadow-black/30">
      {/* Title Bar */}
      <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
        <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
        <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
        <span className="w-3 h-3 rounded-full bg-[#28c840]" />
        <span className="ml-3 text-xs text-[#AC8E66] select-none">kurs</span>
      </div>

      {/* Content */}
      <div className="px-5 sm:px-6 py-5 bg-[#151515] font-mono">
        {/* Course header */}
        <div className="flex items-start gap-3 mb-3">
          {Icon && <Icon className={`w-5 h-5 mt-0.5 ${colorClass}`} />}
          <div>
            <h3 className="text-sm font-semibold text-[#EFEBDC]/90">{course.title}</h3>
            <p className="text-xs text-[#AC8E66] mt-1">
              <span className="text-[#AC8E66]/80">&gt;</span> start: {formattedDate}
            </p>
          </div>
        </div>

        {/* Description */}
        {Array.isArray(course.description) ? (
          <div className="ml-1 mb-4 space-y-0.5">
            {course.description.map((item, index) => (
              <p key={index} className="text-xs text-[#EFEBDC]/50 leading-relaxed">
                <span className="text-[#EFEBDC]/20 mr-1.5">•</span>{item}
              </p>
            ))}
          </div>
        ) : (
          <p className="text-xs text-[#EFEBDC]/50 mb-4 ml-1 leading-relaxed">
            {course.description || "keine beschreibung."}
          </p>
        )}

        {/* Actions */}
        <div className="space-y-2 pt-3 border-t border-[#AC8E66]/10">
          <Link to={`/coursecockpit/${course.id}?${queryParams}`}>
            <button className={btnClass}>[ kurs cockpit → ]</button>
          </Link>

          <ChangeCourseDateModal registrationId={course.id} />

          {pdfUrl && (
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <button className={btnClass}>[ pdf herunterladen → ]</button>
            </a>
          )}

          {pdfUrlSigned ? (
            <a
              href={pdfUrlSigned}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-xs text-green-400/70 underline underline-offset-2 font-mono py-1"
            >
              signiertes pdf ansehen →
            </a>
          ) : (
            <>
              <button
                onClick={() => setOpenSigner(true)}
                className={btnClass}
              >
                [ digital unterschreiben → ]
              </button>

              <PdfSignerModal
                isOpen={openSigner}
                onClose={() => setOpenSigner(false)}
                pdfUrl={pdfUrl}
                onSigned={() => {
                  setOpenSigner(false);
                  window.location.reload();
                }}
                userId={userId}
                course={course.slug}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CourseCardDashboard;
